<script setup lang="ts"></script>
<template>
  <svg
    width="38"
    height="40"
    viewBox="0 0 38 40"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    alt="Twitch Icon"
  >
    <path
      d="M29.5625 8.08594H26.5391V16.6562H29.5547L29.5625 8.08594ZM21.2656 8.04688H18.25V16.625H21.2656V8.04688ZM8.4375 0L0.898438 7.14062V32.8594H9.94531V40L17.4844 32.8594H23.5234L37.1016 20V0H8.4375ZM34.0859 18.5781L28.0547 24.2891H22.0156L16.7344 29.2891V24.2891H9.94531V2.85938H34.0859V18.5781Z"
    />
  </svg>
</template>
